import styled from '@emotion/styled';
import { Button } from '@warbyparker/retail-design-system';

export const CustomerItemButton = styled(Button)`
  padding: 0 24px;
  font-size: 16px;
  margin: 0 0 0 6px;
  width: auto;
`;
